<template>
    <div class="tsi-page">
        <tsi-header></tsi-header>

        <section class="tsi-guide">
            <div class="tsi-container tsi-guide__inner">
                <div class="tsi-section-head">
                    <h2>使用指南</h2>
                    <span>USER GUIDE</span>
                    <i></i>
                </div>

                <p class="tsi-guide__lead">
                    以下手册由系统管理员在后台统一维护，随版本更新，点击即可在新窗口打开。<br/>
                    如需申请账号、开通会议室终端或反馈问题，请联系技术支持 021-54412956。
                </p>

                <div class="tsi-guide__list" v-if="manuals.length">
                    <a v-for="(m, i) in manuals" :key="m.link + i" class="tsi-guide__item"
                       :href="m.link" target="_blank" rel="noopener">
                        <span class="tsi-guide__no">{{ pad(i + 1) }}</span>
                        <span class="tsi-guide__name">{{ m.name }}</span>
                        <span class="tsi-guide__type">{{ m.type }}</span>
                    </a>
                </div>

                <div class="tsi-guide__empty" v-else-if="loaded">
                    暂无公开的操作手册。<br/>
                    手册由系统管理员在后台「用户手册上传」中维护，登录后也可在页面右上角的「手册」菜单中查看。
                </div>

                <div class="tsi-guide__back">
                    <a href="javascript:void(0);" @click="$router.push('/sign-in')">← 返回登录</a>
                </div>
            </div>
        </section>

        <tsi-footer></tsi-footer>
    </div>
</template>

<script>
import TsiHeader from "@/components/tsi-header"
import TsiFooter from "@/components/tsi-footer"
import "@/scss/sign-in-tsi.scss"

export default {
    name: "guide-tsi",
    components: {TsiHeader, TsiFooter},
    data() {
        return {
            manuals: [],
            loaded: false,
        }
    },
    mounted() {
        // 未登录时后端按 role_level <= 0 过滤，只会返回公开手册
        this.$api('Admin.Manual.Manuals', {}).then(res => {
            const list = (res.data && res.data.data) || [];
            this.manuals = list.map(item => {
                const link = item.extra_link ? item.extra_link : item.link;
                return {name: item.name, link: link, type: this.fileType(link)};
            });
            this.loaded = true;
        }).catch(() => {
            this.loaded = true;
        });
    },
    methods: {
        pad(n) {
            return String(n).padStart(2, '0');
        },
        fileType(link) {
            if (!link) return '';
            const m = /\.([a-z0-9]{2,5})(?:[?#]|$)/i.exec(link);
            return m ? m[1].toUpperCase() : '链接';
        },
    },
}
</script>
